<template>
  <div>
    <div class="mb-3">
      <hr />
    </div>

<div class="d-flex gap-3" style="align-items: flex-start;">

  <!-- Panel izquierdo colapsable -->
  <div
    v-show="panelIzquierdoVisible"
    style="width: 280px; min-width: 220px; flex-shrink: 0;"
  >
    <div v-if="cargando" class="text-center py-4">
      <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
      <p class="text-muted small mt-2 mb-0">Cargando archivos...</p>
    </div>
    <div v-else>
      <table class="table table-striped table-hover mb-2">
        <thead class="table-primary">
          <tr>
            <th scope="col" class="d-flex justify-content-between align-items-center">
              <span>Nombre</span>
              <button
                @click="panelIzquierdoVisible = false"
                class="btn btn-sm btn-outline-secondary py-0 px-1"
                title="Ocultar lista"
              >
                <span class="material-icons" style="font-size:15px; vertical-align:middle;">chevron_left</span>
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="archivopla in datosPaginados"
            :key="archivopla.idArchivoPla"
            :class="{ 'table-active fw-bold': selectedDocument?.idArchivoPla === archivopla.idArchivoPla }"
          >
            <td>
              <a href="#" @click.prevent="openDocument(archivopla)"
                class="text-danger text-decoration-none d-block">
                <span class="material-icons align-middle me-1" style="font-size: 15px">
                  {{ getFileIcon(archivopla.tipo) }}
                </span>
                {{ archivopla.nombre }}
              </a>
            </td>
          </tr>
          <tr v-if="datosPaginados.length === 0">
            <td class="text-center text-muted py-4">
              <span class="material-icons mb-1 d-block" style="font-size: 32px; opacity: 0.3">folder_open</span>
              <p class="mb-0 small">Sin archivos</p>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Paginación -->
      <nav v-if="totalPaginas > 1" aria-label="Navegación de archivos">
        <ul class="pagination pagination-sm justify-content-center flex-wrap mb-1">
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <button class="page-link" @click="getPreviousPage">
              <span class="material-icons" style="font-size: 15px">chevron_left</span>
            </button>
          </li>
          <li v-for="pagina in paginasVisibles" :key="pagina"
            class="page-item" :class="{ active: pagina === paginaActual }">
            <button class="page-link" @click="cambiarPagina(pagina)">{{ pagina }}</button>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas }">
            <button class="page-link" @click="getNextPage">
              <span class="material-icons" style="font-size: 15px">chevron_right</span>
            </button>
          </li>
        </ul>
        <div class="text-center text-muted" style="font-size: 0.75rem">
          {{ rangoInicio }}–{{ rangoFin }} de {{ archivoplas.length }}
        </div>
      </nav>
    </div>
  </div>

  <!-- Panel derecho: visor -->
  <div class="border rounded p-3 flex-grow-1" style="min-width: 0;">
    <!-- Botón mostrar lista (solo cuando está oculta) -->
    <div v-if="!panelIzquierdoVisible" class="mb-2">
      <button
        @click="panelIzquierdoVisible = true"
        class="btn btn-sm btn-outline-secondary"
        title="Mostrar lista"
      >
        <span class="material-icons align-middle" style="font-size:15px">chevron_right</span>
        Mostrar lista
      </button>
    </div>

    <div v-if="selectedDocument">
      <!-- Cabecera -->
      <div class="d-flex align-items-center justify-content-between mb-3">
        <div>
          <span class="material-icons align-middle text-danger me-1">
            {{ getFileIcon(selectedDocument.tipo) }}
          </span>
          <strong>{{ selectedDocument.nombre }}</strong>
        </div>
        <a :href="transformarRutaEnURL(selectedDocument.ruta)" target="_blank"
          class="btn btn-sm btn-outline-secondary">
          <span class="material-icons align-middle me-1" style="font-size: 16px">open_in_new</span>
          Abrir
        </a>
      </div>
      <!-- PDF -->
      <div v-if="esPDF(selectedDocument.tipo)">
        <iframe :src="transformarRutaEnURL(selectedDocument.ruta)"
          width="100%" height="600px" class="border rounded"></iframe>
      </div>
      <!-- Imagen -->
      <div v-else-if="esImagen(selectedDocument.tipo)" class="text-center">
        <img :src="transformarRutaEnURL(selectedDocument.ruta)" alt="Vista previa"
          class="img-fluid rounded shadow-sm" style="max-height: 600px" />
      </div>
      <!-- Otro tipo -->
      <div v-else class="text-center py-5 text-muted">
        <span class="material-icons mb-2 d-block" style="font-size: 56px; opacity: 0.3">insert_drive_file</span>
        <p class="mb-3">No se puede previsualizar este tipo de archivo</p>
        <a :href="transformarRutaEnURL(selectedDocument.ruta)" target="_blank"
          class="btn btn-outline-primary">
          <span class="material-icons align-middle me-1" style="font-size: 18px">download</span>
          Descargar archivo
        </a>
      </div>
    </div>

    <!-- Sin selección -->
    <div v-else class="d-flex align-items-center justify-content-center text-muted"
      style="min-height: 300px">
      <div class="text-center">
        <span class="material-icons mb-2 d-block" style="font-size: 56px; opacity: 0.2">preview</span>
        <p class="mb-0">Seleccione un archivo para visualizarlo</p>
      </div>
    </div>
  </div>

</div>

  </div>
</template>

<script>
import api from "@/services/api";
import dateFormat from "@/modules/dateFormat.js";
import Swal from "sweetalert2";

export default {
  name: "ArchivoPlaVisor",

  props: {
    p_idTramite: { type: Number, default: null },
    p_idPlanilla: { type: Number, default: null },
  },

  data() {
    return {
      archivoplas: [],
      paginaActual: 1,
      elementosPorPagina: 10,
      selectedDocument: null,
      cargando: false,
      panelIzquierdoVisible: true,
    };
  },

  computed: {
    totalPaginas() {
      return Math.ceil(this.archivoplas.length / this.elementosPorPagina) || 1;
    },

    datosPaginados() {
      const inicio = (this.paginaActual - 1) * this.elementosPorPagina;
      return this.archivoplas.slice(inicio, inicio + this.elementosPorPagina);
    },

    paginasVisibles() {
      const max = 5;
      let inicio = Math.max(1, this.paginaActual - Math.floor(max / 2));
      let fin = Math.min(this.totalPaginas, inicio + max - 1);
      if (fin - inicio < max - 1) {
        inicio = Math.max(1, fin - max + 1);
      }
      const paginas = [];
      for (let i = inicio; i <= fin; i++) paginas.push(i);
      return paginas;
    },

    rangoInicio() {
      if (this.archivoplas.length === 0) return 0;
      return (this.paginaActual - 1) * this.elementosPorPagina + 1;
    },

    rangoFin() {
      return Math.min(
        this.paginaActual * this.elementosPorPagina,
        this.archivoplas.length
      );
    },
  },

  watch: {
    p_idPlanilla: {
      immediate: true,
      handler(val) {
        if (val && !isNaN(val)) {
          this.paginaActual = 1;
          this.selectedDocument = null;
          this.cargarArchivos();
        }
      },
    },
  },

  methods: {
    async cargarArchivos() {
      this.cargando = true;
      try {
        const { data } = await api.get(
          `/vwarchivoplas/idplanilla/${this.p_idPlanilla}`
        );
        this.archivoplas = data.reverse();
        this.paginaActual = 1;
      } catch (err) {
        console.error("Error cargando archivos:", err);
        Swal.fire({
          icon: "error",
          title: "Error al cargar",
          text: "No se pudieron cargar los archivos",
          confirmButtonColor: "#dc3545",
        });
      } finally {
        this.cargando = false;
      }
    },

    cambiarPagina(pagina) {
      if (pagina >= 1 && pagina <= this.totalPaginas) {
        this.paginaActual = pagina;
      }
    },

    getPreviousPage() {
      if (this.paginaActual > 1) this.paginaActual--;
    },

    getNextPage() {
      if (this.paginaActual < this.totalPaginas) this.paginaActual++;
    },

    openDocument(archivo) {
      this.selectedDocument = archivo;
    },

    esPDF(tipo) {
      return tipo?.toLowerCase().includes("pdf");
    },

    esImagen(tipo) {
      return tipo?.toLowerCase().includes("image");
    },

    getFileIcon(tipo) {
      if (!tipo) return "insert_drive_file";
      const t = tipo.toLowerCase();
      if (t.includes("pdf"))                            return "picture_as_pdf";
      if (t.includes("image"))                          return "image";
      if (t.includes("excel") || t.includes("sheet"))   return "table_chart";
      if (t.includes("word")  || t.includes("doc"))     return "article";
      return "insert_drive_file";
    },

    transformarRutaEnURL(ruta) {
      return "/archivos" + ruta;
    },

    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
  },
};
</script>

<style scoped>
.material-icons {
  vertical-align: middle;
}
.pagination .page-link {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
}
.toggle-btn {
  padding: 4px 6px;
  border-radius: 6px;
  background: #fff;
  border-color: #dee2e6;
  color: #6c757d;
  transition: all 0.15s;
}
.toggle-btn:hover {
  background: #0d6efd;
  color: #fff;
  border-color: #0d6efd;
}
</style>